import React from 'react';
import locale from 'antd/lib/date-picker/locale/pt_BR';
import PropTypes from 'prop-types';
import {
  Checkbox,
  Form,
  Row,
  Col,
  DatePicker,
} from 'antd';
import './Maturador.scss';
import moment from 'moment';

const MaturadorField = (props) => {
  const dateFormat = 'DD/MM/YYYY';

  const {
    rules,
    name,
    value,
    label,
    rulesData,
    nameData,
    valueData,
    labelData,
    edit,
  } = props;

  const handleBrokenBoolean = (brokenValue) => {
    switch (true) {
      case brokenValue === 'true':
      case brokenValue === true:
        return true;

      case brokenValue === 'false':
      case brokenValue === false:
      default:
        return false;
    }
  };

  return (
    <div>
      <Form.Item
        valuePropName="checked"
        name={name}
        rules={rules}
        initialValue={handleBrokenBoolean(value) || false}
      >
        <Checkbox
          className="field-title-text"
          disabled={edit}
        >
          {label}
        </Checkbox>
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={
          (previousValues, currentValues) => {
            return currentValues[name] !== previousValues[name];
          }
        }
      >
        {
          (formInstanceParameter) => {
            if (
              formInstanceParameter.getFieldValue(name) === true
              || formInstanceParameter.getFieldValue(name) === 'true'
            ) {
              return (
                <Row gutter={24} className="inline-field">
                  <Col span={24}>
                    <Form.Item
                      label={<span className="field-title-text">{labelData}</span>}
                      name={nameData}
                      rules={rulesData}
                      initialValue={valueData ? moment(valueData, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]') : undefined}
                    >
                      <DatePicker
                        style={{ width: '100%' }}
                        locale={locale}
                        format={dateFormat}
                        disabled={edit}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              );
            }

            return null;
          }
        }
      </Form.Item>
    </div>
  );
};

MaturadorField.defaultProps = {};
MaturadorField.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  label: PropTypes.element.isRequired,
  rulesData: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  nameData: PropTypes.string.isRequired,
  valueData: PropTypes.any,
  labelData: PropTypes.element.isRequired,
  edit: PropTypes.bool,
};

export default MaturadorField;
